<template>
  <div
    class="m-header"
    v-if="extraItem.extras('nav.display')"
    :style="{
      height: pxOrVw(extraItem.extras('nav.model')),
    }"
  >
    <div class="header-inner">
      <a
        v-if="extraItem.extras('logo.display')"
        class="logo"
        :href="
          extraItem.extras('logo.href')
            ? extraItem.extras('logo.href')
            : 'javascript:;'
        "
        :style="{
          cursor: extraItem.extras('logo.href') ? 'pointer' : 'default',
        }"
        :class="extraItem.extras('logo.size')"
      >
        <img :src="extraItem.extras('logo.src')" alt="" />
      </a>
      <div v-if="langEnabled" class="lang-switcher-wrap">
        <a class="lang-switcher" @click="toggleDropdown">
          <svg
            viewBox="0 0 1024 1024"
            width="18"
            height="18"
            style="vertical-align: middle"
          >
            <path
              d="M951.856 326.935c-24.016-56.778-58.391-107.767-102.174-151.55-43.783-43.783-94.773-78.16-151.55-102.175-58.797-24.868-121.24-37.477-185.599-37.477-64.36 0-126.803 12.61-185.598 37.477-56.778 24.015-107.767 58.392-151.55 102.175s-78.16 94.77-102.175 151.55C48.34 385.73 35.733 448.174 35.733 512.533s12.61 126.804 37.477 185.598C97.225 754.91 131.602 805.9 175.385 849.682c43.782 43.783 94.77 78.16 151.55 102.174 58.794 24.868 121.239 37.477 185.598 37.477 64.359 0 126.802-12.609 185.6-37.477 56.777-24.015 107.767-58.391 151.55-102.174 43.783-43.783 78.158-94.772 102.174-151.55 24.866-58.795 37.476-121.24 37.476-185.599s-12.61-126.803-37.477-185.598zM954.052 496H811.687c-2.925-77.867-22.902-154.284-58.445-223.091 30.652-15.776 59.696-34.308 86.868-55.904C907.452 291.4 949.872 388.267 954.052 496zM530.133 86.99c73.6 41.975 132.182 100.57 174.512 169.618-54.984 23.346-113.712 36.697-174.512 38.989V86.99zM496 295.694c-62.933-2.064-124.192-16.078-181.093-40.838C358.654 184.165 419.2 124.54 496 82.654v213.039z m-169.445 1.889C380.69 317.809 437.333 328.907 496 330.649V496H240.67c2.973-74.667 22.689-146.322 56.063-210.057 9.724 4.32 19.816 7.901 29.822 11.639zM496 530.133v160.19c-58.667 1.747-115.798 12.934-170.146 33.327a536.719 536.719 0 0 0-33.033 13.657c-31.734-63.256-50.158-133.574-52.33-207.174H496z m0 195.146v222.287c-78.933-43.324-141.614-105.597-185.578-179.483 58.143-25.99 120.511-40.689 185.578-42.804z m34.133 0c61.867 2.354 122.746 16.369 178.985 40.904C666.55 838.52 605.867 899.77 530.133 943.23V725.279z m167.984-1.386c-53.83-20.313-110.384-31.585-167.984-33.587V530.133H776.9c-2.15 73.6-19.98 142.525-51.139 205.297-9.105-4.036-18.29-7.913-27.644-11.443zM530.133 496V330.57c57.6-1.993 113.664-13.176 167.287-33.324 8.264-3.106 16.392-5.967 24.466-9.469C754.673 351.044 773.779 421.333 776.72 496H530.133zM815.53 191.213a492.791 492.791 0 0 1-79.399 50.638 504.32 504.32 0 0 0-3.779-6.187A531.293 531.293 0 0 0 577.445 75.436c91.425 13.518 173.816 55.14 238.085 115.777zM437.572 77.04A531.305 531.305 0 0 0 285.04 235.664c-0.86 1.38-1.696 2.773-2.543 4.161a492.817 492.817 0 0 1-74.104-47.536c62.078-58.986 141.23-100.157 229.18-115.248zM183.907 217.937c25.548 20.157 52.728 38.066 81.334 53.106-36.227 69.361-56.579 146.024-59.534 224.957H71.014c4.158-106.667 46.161-203.815 112.893-278.063zM71.014 530.133h134.532c2.171 77.867 21.308 153.581 55.973 222.535-28.046 15.034-54.693 32.65-79.756 52.634C116.274 731.371 75.13 635.733 71.014 530.133z m135.029 300.388a492.69 492.69 0 0 1 72.25-47.156 525.084 525.084 0 0 0 7.372 12.173 531.244 531.244 0 0 0 141.88 150.648C342.5 929.55 266.115 888.444 206.043 830.52z m381.12 117.562a531.3 531.3 0 0 0 144.565-152.545 524.39 524.39 0 0 0 8.598-14.253 492.883 492.883 0 0 1 77.563 50.331c-62.338 59.68-142.068 101.324-230.725 116.467z m255.089-141.636a527.34 527.34 0 0 0-85.31-55.892c33.991-68.382 52.756-142.555 54.905-220.422h142.204c-4.135 106.667-45.7 202.226-111.8 276.314z"
              fill="#555"
            />
          </svg>
          <span class="lang-label">{{ currentLangLabel }}</span>
        </a>
        <ul v-if="dropdownVisible" class="lang-dropdown-menu">
          <li
            v-for="lang in availableLangs"
            :key="lang"
            @click="switchLang(lang)"
            :class="{ active: lang === currentLang }"
          >
            {{ langLabel(lang) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import LangManager from "@/model/lang";

export default {
  name: "Header",
  props: ["extras"],
  data() {
    return {
      langs: LangManager.available.slice(),
      dropdownVisible: false,
      currentLang: LangManager.current,
    };
  },
  computed: {
    langEnabled() {
      const result = LangManager.enabled && this.langs.length > 1;
      return result;
    },
    availableLangs() {
      return this.langs;
    },
    currentLangLabel() {
      return this.langLabel(this.currentLang);
    },
  },
  mounted() {
    // 优先用事件订阅，兜底用轮询（防止 LangManager 在订阅前就 setAvailable）
    this.langs = LangManager.available.slice();
    this._unsub = LangManager.onChange((snapshot) => {
      this.langs = snapshot.available.slice();
      this.currentLang = snapshot.current;
    });
    this.pollLangs();
    // 点击外部关闭下拉
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    if (this._unsub) this._unsub();
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    langLabel(lang) {
      const map = {
        zh_CN: "中文",
        en_US: "English",
        zh_TW: "繁體中文",
      };
      return map[lang] || lang;
    },
    toggleDropdown(e) {
      e.stopPropagation();
      this.dropdownVisible = !this.dropdownVisible;
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.dropdownVisible = false;
      }
    },
    switchLang(lang) {
      this.dropdownVisible = false;
      LangManager.switch(lang);
    },
    pollLangs() {
      let count = 0;
      const timer = setInterval(() => {
        if (LangManager.available.length > 1 || count > 10) {
          this.langs = LangManager.available.slice();
          clearInterval(timer);
        }
        count++;
      }, 100);
    },
    logoClick() {
      if (
        this.extras.logo.href &&
        RegExp("^https?:\\/\\/.+").test(this.extras.logo.href)
      ) {
        window.$sk.goto(this.extras.logo.href);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-header {
  overflow: visible !important;
  position: relative;
  z-index: 100;
}
.m-header .header-inner {
  overflow: visible !important;
  position: relative;
}
.m-header .lang-switcher-wrap {
  position: relative;
  display: inline-block;
  z-index: 99999;
  margin-left: auto;
}
.m-header .lang-switcher {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0 8px;
  color: #555;
  font-size: 14px;
  text-decoration: none;
  user-select: none;
  &:hover {
    color: #1665d8;
  }
}
.m-header .lang-dropdown-menu {
  position: absolute;
  right: 0;
  top: 100%;
  margin: 4px 0 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  min-width: 120px;
  z-index: 99999;
  li {
    padding: 6px 14px;
    cursor: pointer;
    color: #333;
    font-size: 13px;
    white-space: nowrap;
    &:hover {
      background: #f5f5f5;
      color: #1665d8;
    }
    &.active {
      color: #1665d8;
      font-weight: 600;
    }
  }
}
</style>
